module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"course":"课件","commond":"评价"},"TW":{"course":"課件","commond":"評估"},"en":{"course":"Docs ","commond":"Comment"}}')
  delete Component.options._Ctor
}
